import FeaturedProductForm from '@/components/FeaturedProduct/FeaturedProductForm'

let FeaturedProductRouter = [{
  path: '/featured-products',
  name: 'FeaturedProductEdit',
  component: FeaturedProductForm,
  meta: {
    title: 'Produits à la Une',
    requiresAuth: true,
    // Même droit que les autres réglages de la boutique : la sélection est stockée
    // dans axiloc_setting et s'enregistre par la même API.
    authorizations: ['axiloc-setting_edit', 'desktop_access']
  }
}]

export default FeaturedProductRouter



// WEBPACK FOOTER //
// ./src/components/FeaturedProduct/router.js